import translationsStore from './translationsStore';
import oidcStore from './oidcStore';
import usersStore from './usersStore';
import addEditUserStore from './addEditUserStore';
import inviteUserStore from './inviteUserStore';
import authStore from './authStore';
import routesStore from './routesStore';
import teamsStore from './teamsStore';
import authenticationProvidersStore from './authenticationProvidersStore';
import rolesStore from './roles';
import RolesCheckboxListStore from './rolesCheckboxListStore';
import permissionsStore from './permissions';
import commonStore from './commonStore';
import usersGridStore from './usersGridStore';
import firstAdminRegisterationStore from './firstAdminRegisterationStore';
import editUserProfileStore from './editUserProfileStore';
import systemLocalesStore from './systemLocalesStore';
import forgotPasswordStore from './forgotPasswordStore';
import resetPasswordStore from './resetPasswordStore';
import smtpSettingsStore from './smtpSettingsStore';
import resetPasswordByManagerStore from './resetPasswordByManagerStore';
import changePasswordStore from './changePasswordStore';
import teamUsersCheckboxListStore from './teamUsersCheckboxListStore';
import teamMembersStore from './teamMembersStore';
import rootLdapStore from './ldap/rootLdapStore';
import ldapStepperStore from './stepper/ldapStepperStore';
import ldapTeamMappingStore from './ldapTeamMapping/ldapTeamMappingStore';
import groupMapping from './ldap/groupMapping';
import ldapRoleMappingsStore from './ldap/ldapRoleMappingsStore';
import directoryUserMappingStore from './directoryUserMapping';
import windowsDomainsStore from './windowsDomainsStore';
import samlStore from './saml';
import samlServiceProviderStore from './samlServiceProvider';
import serviceProvidersStore from './serviceProviders';
import configurationsStore from './configurationsStore';
import masterAccessControlStore from './masterAccessControlStore';
import twoFAStore from './twoFAStore';
import passwordPoliciesStore from './passwordPoliciesStore';
import adminConfigurationStore from './adminConfigurationStore';
import loginSettingsStore from './loginSettingsStore';
import generatePasswordStore from './generatePasswordStore';

const stores = {
    commonStore,
    translationsStore,
    oidcStore,
    usersStore,
    addEditUserStore,
    inviteUserStore,
    authStore,
    routesStore,
    teamsStore,
    authenticationProvidersStore,
    rolesStore,
    RolesCheckboxListStore,
    permissionsStore,
    usersGridStore,
    firstAdminRegisterationStore,
    editUserProfileStore,
    systemLocalesStore,
    forgotPasswordStore,
    resetPasswordStore,
    smtpSettingsStore,
    resetPasswordByManagerStore,
    changePasswordStore,
    teamUsersCheckboxListStore,
    teamMembersStore,
    rootLdapStore,
    ldapStepperStore,
    ldapTeamMappingStore,
    groupMapping,
    ldapRoleMappingsStore,
    directoryUserMappingStore,
    windowsDomainsStore,
    samlStore,
    samlServiceProviderStore,
    serviceProvidersStore,
    configurationsStore,
    masterAccessControlStore,
    twoFAStore,
    passwordPoliciesStore,
    adminConfigurationStore,
    loginSettingsStore,
    generatePasswordStore
};

export default stores;